

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from 'react-bootstrap';
import { FaImage } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { RiDeleteBin5Line } from "react-icons/ri";
import Swal from "sweetalert2";

const Results = () => {
  const [results, setResults] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [currentImage, setCurrentImage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
 const [visibleCount, setVisibleCount] = useState(20);
const [loading, setLoading] = useState(false);
const [loadingMore, setLoadingMore] = useState(false);



     const filteredData = results.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    
const fetchResults = () => {
  setLoading(true);
  axios
    .get('https://api.scannscore.com/fetch-all-results')
    .then((res) => {
      setResults(res.data);
      setLoading(false);
    
    })
    .catch((err) => {
      console.error('Error fetching data:', err);
      setLoading(false);
    });
};


useEffect(() => {
  fetchResults();
}, []);


useEffect(() => {
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    // when user reaches bottom (threshold 100px)
    if (scrollTop + windowHeight >= docHeight - 100) {
      loadMore();
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => window.removeEventListener("scroll", handleScroll);
}, [filteredData, visibleCount]);


const loadMore = () => {
  if (loadingMore) return;
  if (visibleCount >= filteredData.length) return;

  setLoadingMore(true);

  setTimeout(() => {
    setVisibleCount((prev) => prev + 20);
    setLoadingMore(false);
  }, 300); 
};
 useEffect(() => {
  setVisibleCount(20);
}, [searchTerm]);



const visibleData = filteredData.slice(0, visibleCount);

 
  const handleIconClick = (imgName) => {
    setCurrentImage(`https://api.scannscore.com/uploads/${imgName}`);
    setShowModal(true);
  };

    const handleDelete = async (resultId,omrImg) => {
  const result = await Swal.fire({
    title: "Delete Exam?",
    text: "This will permanently delete the exam and its data. This action cannot be undone.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
      await axios.delete(`https://api.scannscore.com/delete-result/${resultId}/${omrImg}`);

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The exam has been successfully deleted.",
        timer: 1500,
        showConfirmButton: false,
      });

    
   fetchResults();
    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to delete the exam. Please try again.",
      });
    }
  }
};



  const exportToExcel = () => {
    if (!results || results.length === 0) return;

    const data = results.map((r) => ({
      "Student Name": r.student_name,
      "Roll No": r.student_roll_no,
      "Correct": r.correct,
      "Wrong": r.wrong,
      "Penalty": r.penalty,
      "Score": r.score,
      "OMR Image": `https://api.scannscore.com/uploads/${r.omr_img}`, 
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Exam Results");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(fileData, "ExamResults.xlsx");
  };

  if (loading)
    return <p className="text-center mt-3">Loading exam results...</p>;


const calculateScore = (result) => {
  const exam = result;

  let answers = {};
  try {
    answers = JSON.parse(exam.answer || "{}");
  } catch (e) {
    answers = {};
  }

  const questions = exam.questions || [];

  let totalCorrect = 0;
  let totalWrong = 0;
  let attempted = 0;

  const safeNumber = (val) => {
    const n = Number(val);
    return isNaN(n) ? 0 : n;
  };

  const penaltyPerQ = safeNumber(exam.e_penalty);

  questions.forEach((q) => {
    const qNo = String(q.question_no);

    const studentAnswer = String(answers[qNo] ?? "")
      .trim()
      .toUpperCase();

    const correctAnswer = String(q.answer ?? "")
      .trim()
      .toUpperCase();

    const correctMarks = safeNumber(q?.correct_marks ?? exam?.correct_marks);
    const wrongMarks = safeNumber(q?.wrong_marks ?? exam?.wrong_marks);

    if (exam.option_count === 4 && studentAnswer === "E") return;

    if (!studentAnswer || studentAnswer === "-") return;

    attempted++;

    if (studentAnswer === correctAnswer) {
      totalCorrect += correctMarks;
    } else {
      totalWrong += wrongMarks;
    }
  });

  const unattempted = questions.length - attempted;

  const totalPenalty = unattempted * penaltyPerQ;

  const totalScore = totalCorrect - totalWrong - totalPenalty;

  return safeNumber(totalScore);
};
  return (
    <div className="container mt-3">
      <h2 className="mb-4 text-center">Exam Results </h2>

   <div className="mb-3 d-flex justify-content-between align-items-center">

 
  <div style={{ width: "300px" }}>
    <input
      type="text"
      className="form-control border-info"
      placeholder="Search by name, roll no..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
  </div>

  
  <Button  size="sm"
   variant="success" onClick={exportToExcel}>
    Download Excel
  </Button>

</div>
      

      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <thead className="table-dark text-center">
            <tr>
            <th>Sr No.</th>
              <th>Student Name</th>
              <th>Roll No</th>
              <th>Correct</th>
              <th>Wrong</th>
              <th>Penalty</th>
              <th>Score</th>
              <th>Documents</th>
              <th>Action</th>
            </tr>
          
          </thead>
          <tbody>
            {visibleData.map((exam, idx) => (
              <tr key={exam.id} className='text-center'>
                  <td>{idx + 1} </td>
                <td>{exam.student_name}</td>
                <td>{exam.student_roll_no}</td>
                <td>{exam.correct}</td>
                <td>{exam.wrong}</td>
                <td>{exam.e_penalty}</td>
                {/* <td>{exam.score}</td> */}
              <td>  {exam?.option_count === 4
    ? Number(calculateScore(exam)).toFixed(2)
    : Number(exam.score).toFixed(2)}</td>

                <td className="text-center">
                  <FaImage
                    size={25}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleIconClick(exam.omr_img)}
                  />
                </td>

                <td> <RiDeleteBin5Line className='text-danger'  size={20} onClick={() => handleDelete(exam.id,exam.omr_img)} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

     
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>OMR Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img
            src={currentImage}
            alt="OMR Full"
            style={{ maxWidth: '100%', maxHeight: '500px' }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Results;


